import { getWindowFocusFromBrowser } from "../../util/windowFocus.utils";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type WindowFocusState = {
  isWindowFocused: boolean;
};

type WindowFocusActions = {
  setWindowFocus: (isWindowFocused: boolean) => void;
};

const initialState: WindowFocusState = {
  isWindowFocused: getWindowFocusFromBrowser(),
};

export const createWindowFocusSlice: WaterlyAppStateCreator<WindowFocusActions, WindowFocusState> = (
  set,
) => ({
  ...initialState,
  setWindowFocus: (isWindowFocused) => {
    set({ isWindowFocused }, undefined, "windowFocus:setWindowFocus");
  },
});
